export default {
	capitalize(_string) {
		return _string.charAt(0).toUpperCase() + _string.slice(1);
	},
	cutString(longStr, max = 20) {
		const maxChar = max;

		if (longStr.length >= maxChar) {
			return `${longStr.slice(0, maxChar)}...`;
		}
		return longStr;
	},
	isEmpty(string) {
		const expresion1 = String(string).trim().length === 0;
		const expresion2 = string === null;
		const expresion3 = string === undefined;
		const expresion4 = string === 0;

		return expresion1 || expresion2 || expresion3 || expresion4;
	},
	checkZero(field, objectPath) {
		if (objectPath && objectPath[field] !== undefined && objectPath[field] !== null) {
			if (!objectPath[field] || objectPath[field] === "") {
				objectPath[field] = 0;
			}
		}
	},
	isUrl(string) {
		const protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
		const localhostDomainRE = /^localhost(:\d+)?(?:[^\d:?\s]*)$/;
		const nonLocalhostDomainRE = /^[^\s.]+\.\S{2,}$/;
		if (typeof string !== "string") {
			return false;
		}
		const match = string.match(protocolAndDomainRE);
		if (!match) {
			return false;
		}
		const everythingAfterProtocol = match[1];
		if (!everythingAfterProtocol) {
			return false;
		}
		return localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol);
	},
	allowed_extension() {
		return ["jpg", "jpeg", "png", "gif", "bmp", "pdf", "txt", "csv", "xls", "xlsx"];
	},
	checkExt(filename) {
		const extensions = this.allowed_extension();
		let nameFile = filename.name;
		nameFile = nameFile.toLowerCase();
		const ext = nameFile.substr(nameFile.lastIndexOf(".") + 1);
		const isValid = extensions.indexOf(ext) > -1;
		return {valid: isValid, ext};
	},

	genders(url, method, data, onSuccess, onError) {
		return [
			{id: 1, name: "Male"},
			{id: 2, name: "Female"},
			{id: 3, name: "Other"},
		];
	},

	generateDonwloadFile(data, type, fileName) {
		const oMyBlob = new Blob([data], {type});
		const url = URL.createObjectURL(oMyBlob);
		const element = document.createElement("a");
		element.setAttribute("href", url);
		element.setAttribute("download", fileName);
		element.style.display = "none";
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
		return url;
	},
	convertItemObjectToNumbers(object) {
		const result = {};
		for (const key in object) {
			if (object.hasOwnProperty(key)) {
				const value = object[key];
				const numberValue = Number(value);

				// Solo convertir valores que sean números válidos, si no lo es, puedes dejarlo como está
				result[key] = isNaN(numberValue) ? value : numberValue;
			}
		}
		return result;
	},
	addIconSvgWithLabel(color, text, colorText = "black") {
		const template = [
			'<?xml version="1.0"?>',
			'<svg width="30px" height="30px" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">',
			`<circle stroke="#222" fill="#${color}" cx="50" cy="50" r="35"/>`,
			`<text x="50%" y="50%" font-size="30pt" font-family="Arial" font-weight="bold" text-anchor="middle" fill="${colorText}" dy=".3em">` +
				text +
				"</text>" +
				"</svg>",
		].join("\n");
		return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(template);
	},
	addIconSvgWithMarker(color, text) {
		const svgTemplate = [
			`<?xml version="1.0" encoding="UTF-8"?>
			<svg xmlns="http://www.w3.org/2000/svg" width="40px" height="60px" viewBox="0 0 40 60" fill="none" stroke="#${color}">
				<!-- Pin Shape -->
				<path d="M20 0 C10 0, 0 10, 0 20 C0 30, 20 60, 20 60 C20 60, 40 30, 40 20 C40 10, 30 0, 20 0 Z" fill="#${color}" stroke-width="2"/>
				<!-- Text in the Pin -->
				<text x="50%" y="45%" font-size="16pt" font-family="Arial" font-weight="bold" text-anchor="middle" fill="white">${text}</text>
			</svg>`,
		];
		return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgTemplate)}`;
	},
	addIconSvgWithLabelSmall(color) {
		const template = [
			'<?xml version="1.0"?>',
			'<svg width="26px" height="26px" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">',
			'<circle stroke="#222" fill="{{ color }}" cx="50" cy="50" r="35"/>',
			"</svg>",
		].join("\n");
		const svg = template.replace("{{ color }}", `#${color}`);
		return {
			url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
			scaledSize: new google.maps.Size(20, 20),
		};
	},
	customizeListUl(li) {
		for (let item of li) {
			item.style.cssText = `
                background-color: rgb(255, 255, 255);
                color: #626262;
                border: 1px solid #F3F3F3;
                padding: 10px;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: start;
                font-size: 14px;
                `;
		}
	},
	customizeMediaQueryUl(ul) {
		// Estilos comunes
		const baseStyle = `
			display: none;
			background-color: rgb(255, 255, 255);
			line-height: 1.8em;
			padding: 10px;
			width: 200px;
			min-height: auto;
			overflow-y: scroll;`;

		// Modificaciones según el tamaño de la pantalla o la orientación
		if (window.matchMedia("all and (min-width: 1024px) and (max-width: 1280px)").matches) {
			ul.style.cssText = baseStyle + "max-height: 400px;";
		} else if (window.matchMedia("all and (min-width: 768px) and (max-width: 1024px)").matches) {
			ul.style.cssText = baseStyle + "max-height: 600px;";
		} else if (window.matchMedia("all and (min-width: 480px) and (max-width: 768px)").matches) {
			ul.style.cssText = baseStyle + "max-height: 200px;";
		} else if (window.matchMedia("screen and (orientation:portrait)").matches) {
			ul.style.cssText = baseStyle + "max-height: 600px;";
		} else if (window.matchMedia("screen and (orientation:landscape)").matches) {
			ul.style.cssText = baseStyle + "max-height: 300px;";
		} else {
			ul.style.cssText = baseStyle + "max-height: 600px;";
		}
	},
};
